__turbopack_context__.v({
  "cancelButton": "G7GbNa_cancelButton",
  "cancelDialog": "G7GbNa_cancelDialog",
  "closeButton": "G7GbNa_closeButton",
  "discardButton": "G7GbNa_discardButton",
  "footerContainer": "G7GbNa_footerContainer",
});
